import * as Mutation from './mutation-types'

export default {
  [Mutation.SET_EMENTA_ID_CONCLUIDA] (state, ementaIdConcluida) {
    state.ementaIdConcluida = ementaIdConcluida
  }
}
